export class OemConstants {
    static readonly SKU_COMMON = '/modelsku';

    static readonly EQUAL = '=';
    static readonly SLASH = '/';
    static readonly QUESTION = '?';
    static readonly AMP = '&';
    static readonly SLASH_MODELSKUS = '/modelskus';
    static readonly SLASH_ATTRACTORLOOPS = '/attractloops';
    static readonly SLASH_ATTRACTORLOOP = '/oemattractloop';
    static readonly OEMATTRACTORLOOP = 'oemattractloop';
    static readonly SLASH_CONTENTS = '/contents';
    static readonly SLASH_PARTNERS = '/partners';
    static readonly SLASH_USERS = '/users';
    static readonly SLASH_ASSETS = '/assets';
    static readonly SLASH_THUMBNAIL = '/thumbnail';
    static readonly SLASH_VIDEO = '/video';
    static readonly TILE_THUMBNAIL = 'Tile Thumbnail';
    static readonly SYSTEM_ID = 'System ID';
    static readonly LOAD_FLAG = 'Y';
    static readonly UNLOAD_FLAG = 'N';
    static readonly SORTBY = 'sortby';
    static readonly SORTTYPE = 'sorttype';
    static readonly TILE_Video = 'Video';
    static readonly IMAGE = 'Image';
    static readonly THUMBNAIL_ASSETS_PATH = '/assets/thumbnail/';
    static readonly VIDEO_ASSETS_PATH = '/assets/video/';
    static readonly IMAGE_ASSETS_PATH = '/assets/image/';
    static readonly SORT_BY = '?sortby=';
    static readonly SORT_TYPE = '&sorttype=';
    static readonly AND_SORT_BY = '&sortby=';
    static readonly PAGE_NUMBER = '&pagenumber=';
    static readonly CREATED_TIME = 'createdTime&sorttype=desc';
    static readonly QUERY_TYPE = '?type=';
    static readonly SLASH_IMAGE = '/image';
    static readonly LOGO = 'Logo';
    static readonly LOGO_ASSETS_PATH = '/assets/logo/';
    static readonly SLASH_LOGO = '/logo';
    static readonly CONTENTS = 'contents';
    static readonly SYSTEM_ID_FILTER = '?systemIDfilter=';
    static readonly STATIC_VALUE_MODEL_SKU_INFO = $localize`:@@new-partner-content.select-systemid:Select a System ID`;
    static readonly SORTING_UPDATE_DESC = '?sortby=updatedTime&sorttype=desc';
    static readonly CONTENT_LAST_UPDATED = 'updatedtime';
    static readonly ASCENDING_ORDER = 'asc';
    static readonly DESCENDING_ORDER = 'desc';
    static readonly EMPTY_VALUE = '';
    static readonly APPROVED = 'Approved';
    static readonly RETURNED = 'Returned';
    static readonly SUBMITTED = 'Submitted';
    static readonly SAVED = 'Saved';
    static readonly STATUS = 'status';
    static readonly NAME = $localize`:@@attractor-loop.add-button.name:Name`;
    static readonly NEW_ATTRACTOR_LOOP = $localize`:@@attractor-loop.add-button.new-attract-loop:New Attract Loop`;
    static readonly UPDATE_BY_NAME = 'updatedByName';
    static readonly UPDATE_TIME = 'updatedTime';
    static readonly ATTRACTLOOP_NAME = "attractLoopName";
    static readonly STAUS_SUBMITTED = "?status=submitted";

    static readonly UPDATED_TIME = 'updatedTime';
    static readonly UPDATED_BYNAME = 'updatedByName';
    static readonly EDITED_BYNAME = 'editedByName';
    static readonly SUBMIT = 'submit';
    static readonly PARTNERID_SEARCH = '&partneridsearch=';
    static readonly PARTNERID_SEARCH_QUESTION = '?partneridsearch=';
    static readonly CONTENTNAME_PLACEHOLDER = $localize`:@@create-partner-content.placeholder.search:Search by Content Name...`;
    static readonly SYSTEMID_PLACEHOLDER = $localize`:@@model-sku-info.placeholder.searchsystemid:Search by System ID...`;
    static readonly popDisplay = $localize`:@@new-sku-info.poptitle.popDisplay:English Display Name`;
    static readonly englishPalceholder = $localize`:@@new-sku-info.placeholder.englishPalceholder:Enter the Display Name in English`;
    static readonly langPlaceholder = $localize`:@@new-sku-info.placeholder.langPlaceholder:Enter Display Name`;
    static readonly addLocalizedDisplayName = $localize`:@@new-sku-info.placeholder.addLocalizedDisplayName:Add Localized Display Name`;
    static readonly systemId = $localize`:@@new-sku-info.placeholder.systemId:System ID`;
    static readonly systemIdPlaceholder = $localize`:@@new-sku-info.placeholder.systemIdPlaceholder:Enter your Unique System ID`;
    static readonly systemModelsTips = $localize`:@@new-sku-info.placeholder.systemModelsTips:System Model Tips`;
    static readonly systemModelsPlaceholder = $localize`:@@new-sku-info.placeholder.systemModelsPlaceholder:Input the System Models you would like your Hero SKU to apply to`;
    static readonly addButton = $localize`:@@new-sku-info.placeholder.addButton:Add`;
    static readonly cancelButton = $localize`:@@new-sku-info.placeholder.cancelButton:Cancel`;
    static readonly saveButton = $localize`:@@new-sku-info.placeholder.saveButton:Save Model SKU Info`;
    static readonly title = $localize`:@@oem-portal.header.title:IPOS CENTRAL`;
    static readonly myAccount = $localize`:@@oem-portal.header.myAccount:My Account`;
    static readonly notification = $localize`:@@oem-portal.header.notification:Notifications`;
    static readonly logout = $localize`:@@oem-portal.header.logout:Log Out`;
    static readonly modelSkuInfoTab = $localize`:@@oem-portal.tab.modelSkuInfoTab:ENTER MODEL SKU INFO`;
    static readonly createpartnerContentTab = $localize`:@@oem-portal.tab.createpartnerContentTab:CREATE PARTNER CONTENT`;
    static readonly attractorLoopTab = $localize`:@@oem-portal.tab.attractLoopTab:ATTRACT LOOP VIDEOS`;
    static readonly attractorLoopToolTip = 'To create attractor loop for IPOS you’ll need to enter the the Model SKU information for at least one device.';
    static readonly contentGroupToolTip = 'To create content group for IPOS you’ll need to enter the the Model SKU information for at least one device.';

    static readonly SYSTEMID_NAME_PLACEHOLDER = $localize`:@@attract-loop.placeholder.search:Search...`;
    static readonly editAlt = $localize`:@@model-sku-info.alt.editalt:EDIT`;
    static readonly closeAlt = $localize`:@@model-sku-info.alt.closealt:CLOSE`;
    static readonly searchAlt = $localize`:@@model-sku-info.alt.searchalt:SEARCH`;
    static readonly cross_icon = $localize`:@@model-sku-info.alt.cross-icon:CROSS_ICON`;
    static readonly enterContentNamePlaceHolder = $localize`:@@new-partner-content.placeholder.enterContentNamePlaceHolder:Enter Content Name`;
    static readonly tileCtaPlaceHolder = $localize`:@@new-partner-content.placeholder.tileCtaPlaceHolder:Enter Tile CTA`;
    static readonly langCatPlaceHolder = $localize`:@@new-partner-content.placeholder.langCatPlaceHolder:Enter Language Category`;

    static readonly SUBMITTED_STATUS = 'submitted';
    static readonly APPROVED_STATUS = 'approved';
    static readonly RETURNED_STATUS = 'returned';
    static readonly SAVED_STATUS = 'saved';
    static readonly SELECT_PARTNER = $localize`:@@review-partner-content.select-button:Select Partner`;
    static readonly EDIT_TEXT = $localize`:@@review-partner-content.edit-button:Edit`;
    static readonly DELETE_TEXT = 'Delete';
    static readonly IMAGE_SLASH = 'Image/';
    static readonly VIDEO_SLASH = 'Video/';
    static readonly DEV = 'dev';
    static readonly LOCALHOST = 'localhost';
    static readonly QA = 'qa';
    static readonly UAT = 'uat';
    static readonly PREPROD = 'preprod';
    static readonly VIDEO = 'video';
    static readonly SAVE = 'save';

    static readonly PROCESSED_BUCKET = 'asset-library-dev-processed';
    static readonly PROCESSED_BUCKET_DEV = 'asset-library-dev-processed';
    static readonly PROCESSED_BUCKET_QA = 'asset-library-qa-processed';
    static readonly PROCESSED_BUCKET_UAT = 'asset-library-uat-processed';
    static readonly PROCESSED_BUCKET_PREPROD = 'asset-library-preprod-processed';
    static readonly PROCESSED_BUCKET_PROD = 'asset-library-processed';

    static readonly ORIGINAL_BUCKET = 'asset-library-dev-original';
    static readonly ORIGINAL_BUCKET_DEV = 'asset-library-dev-original';
    static readonly ORIGINAL_BUCKET_QA = 'asset-library-qa-original';
    static readonly ORIGINAL_BUCKET_UAT = 'asset-library-uat-original';
    static readonly ORIGINAL_BUCKET_PREPROD = 'asset-library-preprod-original';
    static readonly ORIGINAL_BUCKET_PROD = 'asset-library-original';
    
    static readonly NO_ASSETS = 'No assets found, Please add assets by uploading it from ';
    static readonly APPROVELABEL = $localize`:@@review-comment.approved-label:Approve`;
    static readonly REJECTLABEL = $localize`:@@review-comment.return:Return`;
    //static readonly DONEAPPROVELABEL = $localize`:@@review-comment.approved:Approved`;
    static readonly DONEREJECTLABEL = $localize`:@@review-comment.returned:Returned`;
    static readonly BUTTONLABEL = $localize`:@@review-comment.return-with-comments.btn-text:Return with Comments`;
    static readonly BODY = $localize`:@@view-pages.body:Body`;
    static readonly HEADING = $localize`:@@view-pages.heading:HEADING`;
    static readonly BODYA = $localize`:@@view-pages.bodya:Body A`;
    static readonly BODYB = $localize`:@@view-pages.bodyb:Body B`;
    static readonly COMMENTS_PLACEHOLDER = $localize`:@@view-attract-admin.comments.placeholder:Please enter your feedback for this Attract Loop Video.`;

    static readonly APPROVED_TOOLTIP_DESC = $localize`:@@create-partner-content.approved.tooltip:This Content Group associated to Hero SKU will be included in all future IPOS packages.`;
    static readonly SUBMITTED_TOOLTIP_DESC = $localize`:@@create-partner-content.submitted.tooltip:This Content Group associated to Hero SKU has been shared with the Intel Admin and is pending review.`;
    static readonly RETURNED_TOOLTIP_DESC = $localize`:@@create-partner-content.returned.tooltip:Intel Admin has returned this Content Group. Please edit the content and resubmit the SKU.`;
    static readonly SAVED_TOOLTIP_DESC = $localize`:@@create-partner-content.saved.tooltip:Submit the Content Group associated to Hero SKU to Intel Admin to review.`;

    static readonly SYSTEMID_EXISTS_DESC = $localize`:@@new-sku-info.main-section.systemid.exists:System ID already exists`;
    static readonly SELECT = $localize`:@@create-attractor-loop-oem.label.select-all:Select all`;
    static readonly DESELECT = $localize`:@@create-attractor-loop-oem.label.deselect-all:Deselect all`;
    static readonly SEARCH_SYSTEM_IDS = $localize`:@@create-attractor-loop-oem.placeholder.select-systemid:Search System ID`;
    static readonly SEARCH_COUNTRIES = 'Search';
    static readonly PUSH = 'push';
    static readonly ATTRACT_LOOPNAME = 'attractLoopName';
    static readonly SYSTEM_ID_SEARCHTAG = 'systemIDSearch';
    static readonly ATTRACT_LOOPNAME_SEARCHTAG = 'attractLoopNameSearch';
    static readonly SYSTEM_ID_DISPLAY = 'systemID';
    static readonly DETECTION_STATUS = 'reviewStatus';
    static readonly CONTENT_NAME = 'contentName';
    static readonly LANG_CAT = 'languageCategory';
    static readonly CREATED_BY_NAME = 'createdByName';
    static readonly DUPLICATE_EDIT = 'Duplicate and Edit';
    static readonly COPY_SPACE = 'Copy of ';
    static readonly SPACE_DETAILS = ' Details';
    static readonly CONTENT_GROUP_DETAILS = ' Partner Content Group Details';
    static readonly SKU_ID_SEARCH = 'skuCodeSearch';
    static readonly INTERNAL_NAME_SEARCH = 'internalNameSearch';
    static readonly ATTRACT_LOOP_S3 = '/asset-library-dev-processed';
    static readonly ATTRACT_LOOP_APPROVED_DESC = $localize`:@@attractor-loop.status-approved.desc:The Attract Loop Video information has been approved.`;
    static readonly ATTRACT_LOOP_SUBMITTED_DESC = $localize`:@@attractor-loop.status-submitted.desc:The Attract Loop Video information has been submitted to the Detection Engine.`;
    static readonly ATTRACT_LOOP_RETURNED_DESC = $localize`:@@attractor-loop.status-returned.desc:A conflict has been identified in the Attract Loop Video for this System ID.`;
    static readonly SYSTEM_MODEL = 'System Models';
    static readonly ENGLISH_DISPLAY_NAME = 'English Display name';
    static readonly LAST_UPDATED_CSV = 'Last Updated';
    static readonly LAST_UPDATED_BY = 'Last Updated by';
    static readonly OPERATING_SYSTEM = 'Operating System';
    static readonly SLASH_DOWNLOAD = '/download';
    static readonly MODELS_SKUS = 'Model SKUs';
    static readonly DOWNLOAD_POPUP_CONTENT = 'Download Model SKU information';
    static readonly DOWNLOAD_MODEL_STATUS = 'Status';
    static readonly PUSHTODEVICE = 'pushToDevice=';
    static readonly DISPLAY_NAME = 'displayName';
    static readonly LAST_UPDATED_TIME = 'lastUpdatedTime';
    static readonly SEARCH_SYSTEMID_PLACEHOLDER_TXT = $localize`:@@system-ids.search-systemid-placeholder:Search by System ID...`;
    static readonly SYSTEMIDS = 'systemIDs';
    static readonly APPROVED_POPOVER_TXT = $localize`:@@system-ids.approved-popover-txt:The system model SKU information has been approved`;
    static readonly SUBMITTED_POPOVER_TXT = $localize`:@@system-ids.submitted-popover-txt:The system model SKU information has been submitted to the Detection Engine`;
    static readonly DELETED_POPOVER_TXT = $localize`:@@system-ids.deleted-popover-txt:Request to delete is submitted to the Detection Engine`;   
    static readonly RETURNED_EXISTS_POPOVER_TXT = $localize`:@@system-ids.returned-exists-popover-txt:System IDs/Models already exist. System IDs and associated System Models should be unique.`;   
    static readonly RETURNED_NOT_FOUND_POPOVER_TXT = $localize`:@@system-ids.returned-not-found-popover-txt:System ID is not configured in the Detection Engine. Please contact your Intel representative to get this System ID configured in the Detection Engine.`;   
    static readonly RETURNED_VALIDATION_POPOVER_TXT = $localize`:@@system-ids.returned-validation-popover-txt:System ID should be Uppercase, alphanumeric and spaces should be represented by “_”.`;   
    static readonly RETURNED_ERROR_POPOVER_TXT = $localize`:@@system-ids.returned-error-popover-txt:Please contact your Intel Representative for support`;   
    static readonly PREVIEW_FULL_CONTENT = $localize`:@@partner-content-page.preview-full-content:Preview the full content`;
}
export enum Enumvalues {
    VALUE_1 = '1',
    VALUE_2 = '2'
}
